import React, { useState, useEffect } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';

import { useTranslation } from 'react-i18next';

import UserProfileContext from 'on_web/context/userProfileContext';
import {
  getWorkStatusQuestions,
  getWorktimeQuestions,
  getSelectedWorkPeopleQuestions,
} from 'on_web/helpers/questions';

import { Divider } from '@material-ui/core';

export default function EnvironmentStep1(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedWorkStatus, setSelectedWorkStatus] = useState(
    context &&
      context.user_metadata &&
      context.user_metadata.employmentWorkStatus
      ? context.user_metadata.employmentWorkStatus
      : undefined
  );
  const [selectedWorkTime, setSelectedWorkTime] = useState(
    context && context.user_metadata && context.user_metadata.employmentWorkTime
      ? context.user_metadata.employmentWorkTime
      : undefined
  );
  const [selectedWorkEnvironment, setSelectedWorkEnvironment] = useState(
    context &&
      context.user_metadata &&
      context.user_metadata.employmentWorkEnvironment
      ? context.user_metadata.employmentWorkEnvironment
      : undefined
  );
  const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
  const { t } = useTranslation();

  const onClickNext = () => {
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata) {
      userMetadata.employmentWorkStatus = selectedWorkStatus;
      userMetadata.employmentWorkTime = selectedWorkTime;
      userMetadata.employmentWorkEnvironment = selectedWorkEnvironment;
      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const questionWorkStatus = getWorkStatusQuestions(selectedWorkStatus, t);

  const questionWorkTime = getWorktimeQuestions(selectedWorkTime, t);

  const questionsWorkEnvironment = getSelectedWorkPeopleQuestions(
    selectedWorkEnvironment,
    t
  );

  useEffect(() => {
    if (selectedWorkStatus == null) {
      setNextButtonDisabled(true);
    } else {
      if (
        selectedWorkStatus === 1 &&
        (selectedWorkTime == null || selectedWorkEnvironment == null)
      ) {
        setNextButtonDisabled(true);
      } else {
        setNextButtonDisabled(false);
      }
    }
  });

  return (
    <div>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 4 : 3
          }
        />
      )}

      <Question
        sectionTitle={t(
          'onboarding.environmentSection.environmentStep2.sectionTitle'
        )}
        radioSelection={{ items: questionWorkStatus, twoColumns: true }}
        onAnswer={val => setSelectedWorkStatus(val)}
      />

      {selectedWorkStatus === '1' && (
        <>
          <Divider />
          <Question
            radioSelection={{ items: questionWorkTime, twoColumns: true }}
            onAnswer={val => setSelectedWorkTime(val)}
          />
          <Divider />
          <Question
            radioSelection={{
              items: questionsWorkEnvironment,
              twoColumns: true,
            }}
            onAnswer={val => setSelectedWorkEnvironment(val)}
          />
        </>
      )}

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={nextButtonDisabled}
        editMode={context && context.editMode}
      />
    </div>
  );
}
